import { render, staticRenderFns } from "./BeeMaterialAmountLabel.vue?vue&type=template&id=549048b0&"
import script from "./BeeMaterialAmountLabel.vue?vue&type=script&lang=js&"
export * from "./BeeMaterialAmountLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports